<template>
  <v-layout justify="center">
    <v-dialog v-model="maintenance_type_modal" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            'Nova manutenção'
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-select
                v-model="maintenance.type"
                :items="type"
                item-text="name"
                item-value="id"
                label="Tipo de manuteção: *"
                required
              ></v-select>
              <v-select
                v-model="maintenance.carServiceType"
                :items="carServiceType"
                item-text="name"
                item-value="id"
                label="Tipo de Serviço: *"
                required
                display="none"
                v-if="maintenance.type == 'servico'"
              ></v-select>
              <v-select
                v-model="maintenance.breakdownType"
                :items="breakdownType"
                item-text="name"
                item-value="id"
                label="Tipo de Sinistro: *"
                required
                v-if="maintenance.type == 'sinistro'"
              ></v-select>
              <v-flex xs12 sm12 md12>
                <span class="subheading font-weight-medium">
                  Data e hora de
                  <span class="checkin-text">Inicio</span>
                </span>
                <div style="margin: 10px 0px 15px 0px;" class="form-control">
                  <datetime
                    input-id="inputDate"
                    type="datetime"
                    value-zone="America/Sao_Paulo"
                    zone="America/Sao_Paulo"
                    :min-datetime="dateNow()"
                    :minute-step="getConfigMinuteStep()"
                    v-model="maintenance.begin_date"
                  ></datetime>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <span class="subheading font-weight-medium">
                  Data e hora de
                  <span class="checkin-text">Fim</span>
                </span>
                <div style="margin: 10px 0px 15px 0px;" class="form-control">
                  <datetime
                    input-id="inputDate"
                    type="datetime"
                    value-zone="America/Sao_Paulo"
                    zone="America/Sao_Paulo"
                    :min-datetime="dateNow()"
                    :minute-step="getConfigMinuteStep()"
                    v-model="maintenance.end_date"
                  ></datetime>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="hideModal"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="$emit('btnSim', maintenance)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import DateHelper from '../../helpers/DateHelper';
import { Datetime } from 'vue-datetime';
import Constants from '../../models/constants/Constants';
import ConfigurationController from '../../controllers/ConfigurationController';
import BreakdownController from '../../controllers/BreakdownController';
import CarServicesController from '../../controllers/CarServicesController';
import moment from 'moment';

export default {
  components: {
    Datetime
  },
  props: {
    maintenance_type_modal: Boolean,
  },
  created(){
    this.getSettings();
    this.getBreakdownType();
    this.getCarServiceType();
  },
  
  data() {
    return {
      dateHelper: DateHelper,
      configurationController: new ConfigurationController(this.$resource),
      breakdownController: new BreakdownController(this.$resource),
      carServicesController: new CarServicesController(this.$resource),
      maintenance: {},
      type: [
        { text: 'Serviço', name: 'Serviço', value:'servico', id: 'servico' },      
        { text: 'Sinistro', name: 'Sinistro', value:'sinistro', id: 'sinistro' },      
      ],
      breakdownType: [],
      carServiceType: [],
      settings: {
        price_hour: {
          value: null,
        },
        payment: {
          value: null,
        },
        longitude_visualization: {
          value: null,
        },
        latitude_visualization: {
          value: null,
        },
        request_end_wait_timespan_in_minutes: {
          value: null,
        },
      },
    };
  },
  methods: {
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    getConfigMinuteStep() {
      let valueNotEmpty = !(
        this.settings.request_end_wait_timespan_in_minutes.value === ''
      );
      if (
        this.settings.request_end_wait_timespan_in_minutes.value ||
        valueNotEmpty
      ) {
        return Number(
          this.settings.request_end_wait_timespan_in_minutes.value
        );
      }
      return Number(Constants.CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT);
    },
    async getBreakdownType() {
      await this.breakdownController.getBreakdownType().then(
        breakdownType => {          
          breakdownType.body.forEach(element => {
            this.breakdownType.push({
              id: element.id,
              value: { id: element.id, valor: element.description },
              text: element.description,
              name: `${element.description}`,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getCarServiceType() {
      await this.carServicesController.getCarServiceType().then(
        carServiceType => {          
          carServiceType.body.forEach(element => {
            this.carServiceType.push({
              id: element.id,
              value: { id: element.id, valor: element.description },
              text: element.description,
              name: `${element.description}`,
            });
          });
        },
        err => console.log(err)
      );
    },
    clearForm() {
      this.maintenance = {};
    },
    hideModal() {
      this.clearForm();
      this.$emit('btnNao');
    },
    async getSettings() {
      let configs = await this.configurationController.getAll(this.clienteId);
      this.settings = configs;
    },
  },
};
</script>
